<avi-continue-confirmation-dialog
    [customHeader]="header"
    [warning]="warning"
    (onClose)="handleCancel()"
    (onConfirm)="handleContinue()"
></avi-continue-confirmation-dialog>
